import { Button, Input, Slider, Table, Tag } from 'antd';
import styled from 'styled-components';
import ListFilters from './ListFilters';
import { CSVLink } from 'react-csv';

const ButtonGroup = Button.Group;

export const Wait4MeContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 160px;
  align-items: center;
`;

export const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-thead {
    tr {
      .ant-table-cell {
        padding: 0.5rem;
        background: #fff;
        vertical-align: top;
        font-size: 12px;
        font-weight: 700;
        font-style: normal;
        line-height: 14.52px;
        color: #748aa1;

        &:nth-child(2) {
          padding-left: 0.8rem;
        }
      }
    }
  }
  .ant-table-tbody {
    tr {
      .ant-table-cell {
        padding: 0.6rem 0.5rem;
        font-style: normal;
        font-weight: normal;
        font-size: 11px;
        line-height: 12px;
        color: #000000;
        strong {
          font-weight: 500;
        }
        border-bottom: 8px solid #ffffff;
        border-top: 8px solid #ffffff;
        word-break: break-all;

        &:nth-child(2) {
          padding-left: 0.8rem;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          box-shadow: 4px 0px 0 rgba(223, 96, 87, 0.2) inset;
        }
      }
    }
    .ant-table-row {
      .ant-table-cell {
        background-color: #fff;
        &:not(:first-of-type) {
          background-color: #0e276105;
        }
      }
      &:hover {
         cursor:pointer;
        .ant-table-cell {
          background-color: #fff;
          &:not(:first-of-type) {
            background-color: rgba(43, 115, 224, 0.15);
          }
        }
      }
    }
    .ant-table-row-selected {
      .ant-table-cell {
        background-color: #fff;
        &:not(:first-of-type) {
          background-color: rgba(43, 115, 224, 0.2);
        }
      }
      &:hover {
        .ant-table-cell {
          background-color: #fff;
          &:not(:first-of-type) {
            background-color: rgba(43, 115, 224, 0.25);
          }
        }
      }
    }
    .ant-table-selection-column {
      pointer-events: none;
      .ant-checkbox-wrapper {
        pointer-events: auto;
      }
    }
  }
  .ant-pagination {
    .ant-pagination-item {
      color: #31394d;
      border-radius: 4px;
    }
    .ant-pagination-item-active {
      color: #21b4bd;
      border-color: #21b4bd;
    }

    .ant-pagination-total-text {
      color: #b8bec5;
      line-height: 2rem;
      flex: 1;
    }

    .ant-pagination-item-link {
      border-radius: 4px;
    }
    .anticon {
      vertical-align: text-top;
    }
  }
`;

export const StyledSlider = styled(Slider)`
  margin-left: 4px;

  .ant-slider-mark {
    font-size: 10px;
  }
`;

export const StyledInputGroup = styled(Input.Group)`
  padding-left: 15px;
  .ant-input-number {
    width: 56px;
    color: #eb9229;
  }

  .ant-input-number:hover {
    border-color: #d9d9d9 !important;
  }

  .ant-input-number-input {
    width: 56px;
    padding: 4px 6px;
    text-align: center;
  }

  .site-input-left:not(:hover) {
    border-right-width: 0 !important;
  }

  .site-input-split {
    width: 8px;
    border-left: 0px;
    border-right: 0px;
    padding: 4px 0px;
    pointer-events: none;
    background-color: #fff;
    z-index: 1;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }

  .site-input-right {
    border-left-width: 0;
  }

  .ant-input-rtl.site-input-right {
    border-right-width: 0;
  }

  .ant-input-rtl.site-input-right:hover,
  .ant-input-rtl.site-input-right:focus {
    border-right-width: 1px;
  }
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  &.ant-btn-group > .ant-btn:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &.ant-btn-group > .ant-btn:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  & button {
    background: transparent;
    border-color: #91bced;
  }
  & button {
    &.selected {
      background: #91bced;
      color: #fff;
    }
  }
`;

export const StyledAlertListFilters = styled(ListFilters)`
  flex-direction: column;

  & > * {
    margin: 0 0 12px 0;
  }

  .DateRangeWithPresets-root .DateRangeWithPresets-duration {
    margin: 0 0 12px 0;
  }
`;

export const StyledSearch = styled(Input.Search)`
  width: 225px;
  .ant-input-affix-wrapper {
    border-bottom-left-radius: 8px !important;
    border-top-left-radius: 8px !important;
  }
  .ant-input-search-button {
    border-bottom-right-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
`;

export const StyledCSVLink = styled(CSVLink)`
  &:hover {
    text-decoration: none !important;
  }
`;

export const StyledTag = styled(Tag)`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const StyledTagDiv = styled.div`
  display: flex;
  flex-direction: column;
  label {
    margin-bottom: 0;
  }
`;

export const StyledLevelColor = styled.span`
  &&& {
    border: 1px solid transparent;
    border-radius: 8px;
    width: 13px;
    height: 8px;
    padding: 0 !important;
    margin-right: 6px;
    background: ${(props) => props.color};

    &:hover {
      border: 1px solid #ffffff;
    }
  }
`;
